import apiClient from 'apiClient';
import { SaveData } from './types';
import { firmDataMapper } from 'utils/api/admins/dataMapper';
import { SubmissionRouteType } from 'components/Profile/CmNetworkProfile/types';
import { AxiosPromise } from 'axios';
import { Nullable } from 'utils/types';

export const fetchFirmDetails = async (firmId: string): Promise<any> => {
  const { data } = await apiClient.get(`/api/v1/broker-management/firms/${firmId}`);
  const commissionTermsData = await apiClient.get(`/api/v1/broker-management/firm/${firmId}/commission-terms`);

  return firmDataMapper.map({
    data: {
      ...data.data,
      commission_terms: commissionTermsData.data,
    },
    resources: data.resources,
  });
};

export const updateFirm = (firmId: string, values: SaveData): Promise<any> => {
  return apiClient.post(`/api/v1/broker-management/update-firm/${firmId}`, values);
};

export const changeSubmissionRoute = (
  firmId: string,
  entityId: Nullable<string>,
  submissionRouteType: SubmissionRouteType,
): AxiosPromise<void> => {
  return apiClient.post(`/api/v1/broker-management/update-firm/${firmId}/change-preferred-submission-route`, {
    entity_id: entityId,
    submission_route_type: submissionRouteType,
  });
};
